export default __webpack_public_path__ + "static/media/information--telephone--g2.e30d7202.png";